var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.19967 12.7798L7.49967 7.47981L10.7497 10.7298C11.1597 11.1398 11.8197 11.1198 12.1997 10.6898L19.3697 2.61981C19.7197 2.22981 19.6997 1.62981 19.3297 1.24981C19.2336 1.154 19.119 1.07876 18.9928 1.02865C18.8667 0.978553 18.7317 0.954646 18.5961 0.958388C18.4604 0.96213 18.327 0.993444 18.2038 1.05042C18.0806 1.1074 17.9703 1.18885 17.8797 1.28981L11.4897 8.46981L8.19967 5.17981C8.10716 5.08711 7.99727 5.01356 7.87629 4.96338C7.75532 4.9132 7.62564 4.88737 7.49467 4.88737C7.3637 4.88737 7.23402 4.9132 7.11305 4.96338C6.99207 5.01356 6.88218 5.08711 6.78967 5.17981L0.699671 11.2798C0.606967 11.3723 0.533419 11.4822 0.483238 11.6032C0.433057 11.7242 0.407227 11.8538 0.407227 11.9848C0.407227 12.1158 0.433057 12.2455 0.483238 12.3664C0.533419 12.4874 0.606967 12.5973 0.699671 12.6898L0.78967 12.7798C1.17967 13.1698 1.81967 13.1698 2.19967 12.7798Z",
    fill: "#151A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.3a6c563be295f44765ab618f53e8c2bf.svg";
export { ForwardRef as ReactComponent };